import fromUnixTime from 'date-fns/fromUnixTime';
import getUnixTime from 'date-fns/getUnixTime';
import addMinutes from 'date-fns/addMinutes';
import isBefore from 'date-fns/isBefore';
import diffMs from 'date-fns/differenceInMilliseconds';
import Logger from 'utilities/logger';

const TIMERS = {};

const keyCharAt = (key, i) => key.charCodeAt(Math.floor(i % key.length));
const encrypt = data =>
  data
    .split('')
    .map(
      (c, i) =>
        c.charCodeAt(0) ^ keyCharAt('94F54F69B73909C84532B7E11ABD042D', i),
    );

const prepare = key => `m_t:${btoa(encrypt(key))}`;

const get = key => {
  const storage = window.sessionStorage;
  const token = storage.getItem(prepare(key));
  if (token) {
    const { ttl, value } = JSON.parse(token);
    if (isBefore(fromUnixTime(ttl), new Date())) {
      storage.removeItem(prepare(key));
      return null;
    }
    return value;
  }
  return null;
};

const set = (key, value) => {
  const storage = window.sessionStorage;
  const ttl = getUnixTime(addMinutes(new Date(), 30));
  return storage.setItem(prepare(key), JSON.stringify({ ttl, value }));
};

const clear = () => {
  const storage = window.sessionStorage;
  const keys = Object.keys(storage);
  Object.values(TIMERS).forEach(timer => clearTimeout(timer));
  for (const key of keys) {
    if (key.startsWith('m_t:')) {
      storage.removeItem(key);
    }
  }
};

const request = async (auth, scope) => {
  const logger = Logger('Token Manager');
  const originalScope = scope;

  if (Array.isArray(scope)) {
    scope = scope.join(',');
  }

  if (scope === undefined) {
    logger.warn('Cannot request undefined');
    return null;
  }

  logger.debug(`Request ${scope}`);
  try {
    const token = await auth.accessToken(originalScope);
    set(`token_${scope}`, token.accessToken);
    logger.debug(`Response ${scope}`, token);
    const { expiresAt: expiresAtUnix } = token;
    const expiresAt = fromUnixTime(expiresAtUnix);
    const msTillExpiration = diffMs(expiresAt, new Date());
    logger.debug({ scope, expires: expiresAt.toLocaleString() });
    TIMERS[originalScope] = setTimeout(
      () => request(originalScope),
      msTillExpiration - 10000,
    );
    return token.accessToken;
  } catch (err) {
    logger.debug(`Error on ${scope}`);
    logger.error(err);
    return null;
  }
};

export default { get, clear, request };
